import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import 'leaflet/dist/leaflet.css';

// Add Google Analytics initialization
const initializeGoogleAnalytics = () => {
  // Check if gtag is already loaded
  if (typeof window.gtag !== 'undefined') {
    return;
  }
  
  const script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-SZ60HSMK51';
  script.async = true;
  document.head.appendChild(script);

  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-SZ60HSMK51');
  `;
  document.head.appendChild(script2);
};

// Initialize Google Analytics
initializeGoogleAnalytics();

// Create root and render app
const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('Failed to find the root element');
} else {
  const root = createRoot(rootElement);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}